export default __webpack_public_path__ + "static/reactHooks-2a1c7b9ffdf35ef4a121567ec1a7235e.svg";